import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Format the date to "dd MMM yyyy
export const formatDate = (date: Date) =>
  date
    .toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(",", ""); // Remove the extra comma (if any)

interface Coordinates {
  lat: number;
  lon: number;
}

export const calculateDistance = (
  lat1: Coordinates["lat"],
  lon1: Coordinates["lon"],
  lat2: Coordinates["lat"],
  lon2: Coordinates["lon"],
  unit: "km" | "miles" = "km"
): number => {
  const R = unit === "km" ? 6371 : 3958.8 // Earth radius in km or miles
  const dLat = (lat2 - lat1) * (Math.PI / 180)
  const dLon = (lon2 - lon1) * (Math.PI / 180)

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * (Math.PI / 180)) *
    Math.cos(lat2 * (Math.PI / 180)) *
    Math.sin(dLon / 2) ** 2

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const distance = R * c

  return parseFloat(distance.toFixed(0))
}

// Function to mask phone number
export const maskPhoneNumber = (phone: string) => {
  if (!phone) return '';
  return `${phone.slice(0, 2)}****${phone.slice(-4)}`;
};

// Format timer to MM:SS
export const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

// Convert 24-hour format to 12-hour format with AM/PM
export const formatTimeTo12Hour = (time24: string) => {
  if (!time24) return '';
  
  const [hours, minutes] = time24.split(':');
  const hour24 = parseInt(hours, 10);
  const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
  const ampm = hour24 >= 12 ? 'PM' : 'AM';
  
  return `${hour12}:${minutes} ${ampm}`;
};